import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconLogout = function IconLogout(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-logout"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.293 3.79297C15.293 2.96454 14.6214 2.29297 13.793 2.29297H3.79297C2.96454 2.29297 2.29297 2.96454 2.29297 3.79297V18.793C2.29297 19.6214 2.96454 20.293 3.79297 20.293H13.793C14.6214 20.293 15.293 19.6214 15.293 18.793V16.793C15.293 16.5168 15.0691 16.293 14.793 16.293H13.793C13.5168 16.293 13.293 16.5168 13.293 16.793V18.293H4.29297L4.29297 4.29297L13.293 4.29297V5.79297C13.293 6.06911 13.5168 6.29297 13.793 6.29297H14.793C15.0691 6.29297 15.293 6.06911 15.293 5.79297V3.79297ZM21.3535 11.6465C21.5487 11.4512 21.5487 11.1346 21.3535 10.9394L18.3535 7.93937C18.1582 7.74411 17.8416 7.74411 17.6464 7.93937L16.9393 8.64648C16.744 8.84174 16.744 9.15832 16.9393 9.35358L17.8786 10.2929L7.79282 10.2929C7.51668 10.2929 7.29282 10.5168 7.29282 10.7929V11.7929C7.29282 12.0691 7.51668 12.2929 7.79282 12.2929H17.8786L16.9393 13.2323C16.744 13.4275 16.744 13.7441 16.9393 13.9394L17.6464 14.6465C17.8416 14.8417 18.1582 14.8417 18.3535 14.6465L21.3535 11.6465Z",
    fill: "currentColor"
  })));
};

export { IconLogout };
